"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLoggedIn = void 0;
const React = __importStar(require("react"));
const SkeletonComponent_1 = require("src/hello_assets/src/components/ui/common/common/SkeletonComponent");
const ToolbarComponent_1 = require("src/hello_assets/src/components/ui/loggedin/toolbar/ToolbarComponent");
const RootContentComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/RootContentComponent");
const ProjectsProvider_1 = __importDefault(require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const MainRedirectComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/MainRedirectComponent");
const usergeek_ic_js_1 = require("usergeek-ic-js");
const ActorsProvider_1 = require("src/hello_assets/src/components/system/actor/ActorsProvider");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const USERGEEK_PROJECT_API_KEY = "0187010184CBAC14D9AEC05A126DF660"; //https://fbbjb-oyaaa-aaaah-qaojq-cai.raw.ic0.app/project/0187010184CBAC14D9AEC05A126DF660
const USERGEEK_PROJECT_API_KEY_TEST = "015C01A91DAA27852540F4EA9CD48EFE"; //https://fbbjb-oyaaa-aaaah-qaojq-cai.raw.ic0.app/project/015C01A91DAA27852540F4EA9CD48EFE
const USERGEEK_PROJECT_API_KEY_DEV = "01FA0101B5438F312870B7ED85B3D5F7";
const AppLoggedIn = () => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const currentPrincipal = authProviderContext.getCurrentPrincipal();
    React.useEffect(() => {
        if (currentPrincipal) {
            if (process.env.NODE_ENV === "development") {
                // return
                usergeek_ic_js_1.Usergeek.init({
                    apiKey: USERGEEK_PROJECT_API_KEY_DEV,
                    debugConfiguration: {
                        loggerLog: function () {
                            const args = [].slice.call(arguments);
                            args.unshift("Usergeek Log:");
                            console.log([].slice.call(args));
                        },
                        loggerWarn: function () {
                            const args = [].slice.call(arguments);
                            args.unshift("Usergeek Warn:");
                            console.warn([].slice.call(args));
                        },
                        loggerError: function () {
                            const args = [].slice.call(arguments);
                            args.unshift("Usergeek Error:");
                            console.error([].slice.call(args));
                        }
                    }
                });
            }
            else if (!!process.env.IS_TEST_SERVER) {
                usergeek_ic_js_1.Usergeek.init({ apiKey: USERGEEK_PROJECT_API_KEY_TEST, host: "https://ic0.app" });
            }
            else {
                usergeek_ic_js_1.Usergeek.init({ apiKey: USERGEEK_PROJECT_API_KEY, host: "https://ic0.app" });
            }
            usergeek_ic_js_1.Usergeek.setPrincipal(currentPrincipal);
            usergeek_ic_js_1.Usergeek.trackSession();
        }
    }, [currentPrincipal]);
    return React.createElement(ActorsProvider_1.ActorsProvider, null,
        React.createElement(ProjectsProvider_1.default, null,
            React.createElement(MainRedirectComponent_1.MainRedirectComponent, null,
                React.createElement(CurrentProjectProvider_1.CurrentProjectProvider, null,
                    React.createElement(SkeletonComponent_1.SkeletonComponent, { toolbarComponent: ToolbarComponent_1.ToolbarComponent, contentComponent: RootContentComponent_1.RootContentComponent })))));
};
exports.AppLoggedIn = AppLoggedIn;
